import React, { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { HotelCardContext } from 'components/HotelCardContext';
import { UnavailabilityMobile } from 'components/Unavailability/Mobile';
import { UnavailabilityWithChangeDates } from 'components/Unavailability/UnavailabilityComponent/UnavailabilityWithChangeDates';
import { UnavailabilityWithPopupTrigger } from 'components/Unavailability/UnavailabilityComponent/UnavailabilityWithPopupTrigger';
import { showAvailabilityPopup, showDatePicker } from 'modules/overlay/actions';
import { hideOverlay } from 'modules/overlay/slice';
import { getHotelAvailabilityPrices, getHotelAvailabilityPricesComplete } from 'modules/sapiSearch/selectors';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { useDispatchTeamEvent } from '@daedalus/core/src/analytics/components/TeamContext';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
import { DatePickerType } from '@daedalus/core/src/datePicker/types';
interface Props {
  sourceComponent: string;
}
const UnavailabilityWrapper = /*#__PURE__*/styled('div')({
  name: "UnavailabilityWrapper",
  class: "uu1gw8x",
  propsAsIs: false
});
const UnavailabilityMobileWrapper = /*#__PURE__*/styled('div')({
  name: "UnavailabilityMobileWrapper",
  class: "u1ykwvv7",
  propsAsIs: false
});
const HotelCardUnavailabilityComponent = ({
  sourceComponent
}: Props) => {
  const dispatch = useDispatch();
  const dispatchTeamEvent = useDispatchTeamEvent();
  const {
    isMobile,
    isDesktopXs
  } = useDeviceLayout();
  const {
    hotelId,
    isAnchor
  } = useContext(HotelCardContext);
  const hotelAvailabilityPrices = useSelector(state => getHotelAvailabilityPrices(state, hotelId));
  const availabilitySearchComplete = useSelector(getHotelAvailabilityPricesComplete);
  const hasHotelAvailabilityPrices = Boolean(hotelAvailabilityPrices);
  const isAvailabilityDataLoading = !hasHotelAvailabilityPrices && !availabilitySearchComplete;
  const handleChangeDatesClick = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    dispatchTeamEvent(trackEvent({
      category: Category.User,
      entity: Entity.SoldOutChangeDatesButton,
      action: Action.Clicked
    }));
    dispatch(hideOverlay());
    dispatch(showDatePicker(DatePickerType.CheckIn));
  }, [dispatchTeamEvent, dispatch]);
  const handleShowAvailabilityPopup = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    dispatchTeamEvent(trackEvent({
      category: Category.User,
      entity: Entity.AvailabilityPaneSeeMore,
      action: Action.Clicked,
      component: sourceComponent
    }));
    showAvailabilityPopup(dispatch);
  }, [dispatchTeamEvent, dispatch]);
  if (isMobile || isDesktopXs) {
    return <UnavailabilityMobileWrapper>
        <UnavailabilityMobile hotelId={hotelId} sourceComponentPrefix="MobileHotelView" />
      </UnavailabilityMobileWrapper>;
  }
  return <UnavailabilityWrapper className={cx(isAnchor && '__isTopAligned', '__isUAImprovementsASide')} data-id="SoldOutPane">
      {isAnchor ? <UnavailabilityWithPopupTrigger handleShowAvailabilityPopup={handleShowAvailabilityPopup} handleChangeDatesClick={handleChangeDatesClick} showViewPopupCalendar={hasHotelAvailabilityPrices} isLoading={isAvailabilityDataLoading} /> : <UnavailabilityWithChangeDates hasCompactButton handleChangeDatesClick={handleChangeDatesClick} />}
    </UnavailabilityWrapper>;
};
export const HotelCardUnavailability = React.memo(HotelCardUnavailabilityComponent);

require("./HotelCardUnavailability.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./HotelCardUnavailability.tsx");